export const isMarketingProductPath = (pathname) =>
  /^\/retailers\/[^/]+\/marketing(\/|$)/.test(pathname);
